export function getMediaAspectRatio(media, fallback) {
    return media.dimensions ? media.dimensions.width / media.dimensions.height : fallback;
}
//# sourceMappingURL=getMediaAspectRatio.js.map